//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ColumnsSelect from '@/components/ColumnsSelect'
import CobranzasAPI from "@/api/promotores/cobranzas.api";
import CobranzaForm from './CobranzaForm'
import CobranzaEdit from './CobranzaEdit'

export default {
  components: {
    CobranzaForm,
    ColumnsSelect
  },

  data() {
    return {
      cobranzas: [],
      visible_columns: [
        'cuenta',
        'nombre',
        'direccion',
        'usuario',
        'status',
        'created_at',
        'actions',
      ],
      columns: [
        {
          name: "cuenta",
          label: "Cuenta ID",
          field: "cuenta",
          align: "left",
          sortable: true,
          required: true,
        },
        {
          name: "nombre",
          label: "Nombre",
          field: "nombre",
          align: "left",
          sortable: true,
          classes: "bg-grey-2 ellipsis",
          style: "width: 300px",
          headerClasses: "bg-primary text-white",
          required: true,
        },
        {
          name: "direccion",
          label: "Dirección",
          field: "direccion",
          align: "left",
        },
        {
          name: "usuario",
          label: "Promotor",
          field: "usuario",
          align: "left",
        },
        {
          name: "telefono",
          label: "Teléfono",
          field: "telefono",
          align: "left",
        },
        {
          name: "email",
          label: "E-mail",
          field: "email",
          align: "left",
        },
        { name: "adeudo", label: "Adeudo", field: "adeudo", align: "left", format: this.currency, },
        {
          name: "recompensa",
          label: "Recompensa",
          field: "recompensa",
          align: "left",
          format: this.currency,
        },
        {
          name: "calificacion",
          label: "Calificación",
          field: "calificacion",
          align: "left",
        },
        {
          name: "status",
          label: "Estado",
          field: "status",
          align: "left",
          sortable: true,
          required: true,
        },
        {
          name: "created_at",
          label: "Creación",
          field: "created_at",
          align: "left",
          sortable: true,
        },
        {
          name: "actions",
          label: "Acciones",
          required: true,
        }
      ],
      loading: false,
      status: [
        { value: "creada", label: "Creada" },
        { value: "aceptada", label: "Aceptada" },
        { value: "en proceso", label: "En proceso" },
        { value: "concluida", label: "Concluida" },
        { value: "cerrada", label: "Cerrada" },
      ],
    };
  },

  mounted() {
    this.loadCobranzas();
  },

  methods: {
    async loadCobranzas() {
      try {
        this.loading = true;
        this.cobranzas = await CobranzasAPI.all();
      } finally {
        this.loading = false;
      }
    },

    async updateStatus({ _id, status }) {
      this.loading = true;
      await CobranzasAPI.update(_id, { status });
      this.loading = false;
    },

    async rating({ _id, calificacion }) {
      this.loading = true;
      await CobranzasAPI.update(_id, { calificacion });
      this.loading = false;
    },

    openCobranzaCreate() {
      this.$q.dialog({
        component: CobranzaForm
      })
        .onOk(() => {
          this.loadCobranzas()
        })
    },

    openCobranzaEdit(cobranza) {
      this.$q.dialog({
        component: CobranzaEdit,
        cobranzaId: cobranza._id
      })
        .onOk((changes) => {
          this.loadCobranzas()
        })
    },

    async desasignarCobranza(cobranza) {
      this.loading = true;
      await CobranzasAPI.update(cobranza._id, { status: 'creada', usuario_id: null });
      this.loading = false;
      this.loadCobranzas()
    }
  },
};
